import React, { Component } from 'react';
import { connect } from 'react-redux';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import {Switch, Route, Redirect} from 'react-router-dom';
import Auth from './Views/Advertisers/Auth';
import Dashboard from './Views/Advertisers/Dashboard';
import './App.css'
import 'firebase/auth'
import {isAuthenticated} from "./Helpers";

const THEME = createMuiTheme({
  typography: {
   fontFamily: `"Avenir", sans-serif !important`,
  },
  overrides: {
    MuiButton: {
      root: {
        borderRadius: '10px',
      },
      '&:hover': {
        backgroundColor: '#03A9F4',
      }
    }
  }
});

class App extends Component {
  render () {
    return (
      <MuiThemeProvider theme={THEME}>
        <Switch>
          <Route path='/auth' component={Auth} />
          {!isAuthenticated() && (
            <Redirect to='/auth' />
          )}
          <Route path='/' component={Dashboard} />
        </Switch>
      </MuiThemeProvider>
    )
  }
}

const mapStateToProps = state => {
  return {
    auth: state.r_auth.authenticated, // state.auth (this is for what is in combinereducer)
    advertiserId: state.r_advertiser.advertiser.advertiser_id
  }
};

export default connect(mapStateToProps)(App);
